import { AggregateMetaData } from '../meta-data';
import { RootViewModel } from './root-view-model';
import { ClassConstructor } from '@nts/std/serialization';
import { CollectionViewModelInterface, CoreOrchestratorViewModelInterface, IdentityInterface, ItemViewModelInterface, ModelInterface } from '@nts/std/interfaces';

export class RootViewModelItem<TModel extends ModelInterface<TIdentity>, TIdentity extends IdentityInterface>
    extends RootViewModel<TModel, TIdentity> implements ItemViewModelInterface {

    async initItemViewModel(
        domainModel: TModel,
        metadata: AggregateMetaData,
        orchestratorViewModel: CoreOrchestratorViewModelInterface,
        ownerCollection?: CollectionViewModelInterface<any>,
        isNewItem?: boolean,
        path?: string,
        isMock: boolean = false,
        domainModelType: ClassConstructor<TModel> = null
    ) {
        this.isMock = isMock;
        
        await this.initAggregateElementViewModel({
            domainModel,
            aggregateMetaData: metadata,
            orchestratorViewModel,
            isMock,
            domainModelType
        });
    }
}
